import { render, staticRenderFns } from "./AbacusRandom.vue?vue&type=template&id=06152683&"
import script from "./AbacusRandom.vue?vue&type=script&lang=js&"
export * from "./AbacusRandom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports